export default __webpack_public_path__ + "assets/item3.62e2ebb124f8f5a9386bdf7dc018cd22.png";